import script from "./dealerlist.vue?vue&type=script&setup=true&lang=js"
export * from "./dealerlist.vue?vue&type=script&setup=true&lang=js"

import "./dealerlist.vue?vue&type=style&index=0&id=ea021344&scoped=true&lang=css"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-POP-PROD\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea021344"]])

export default __exports__